module.exports = __webpack_public_path__ + "static/media/G0142657_China-26.65282135.png";